import axios from 'axios'
import { Config } from '../../configs/Config'
import { autorun } from 'mobx'
import accountStore from '../../stores/AccountStore'
import { oktaAuth } from '../../App'
import { captureException, setTag } from '@sentry/react'

accountStore.getActor()
accountStore.getClientnumber()
const KetenverbandClient = axios.create({
  baseURL: Config.api.host,
})

export const getTokenFromAccountStore = (): Promise<string | undefined> => {
  return new Promise(resolve => {
    autorun(() => {
      if (accountStore.isAuthenticated) {
        resolve(accountStore.accessToken?.accessToken)
      }
    })
  })
}

KetenverbandClient.interceptors.request.use(
  async config => {
    const { accessToken } = await oktaAuth.tokenManager.getTokens()
    if (accessToken?.accessToken) {
      config.headers.Authorization = 'Bearer ' + accessToken.accessToken
    }
    return config
  },
  (
    error // Do something with request error
  ) => {
    setTag('errorLocation', 'KetenverbandClient')
    captureException(error)
    Promise.reject(error)
  }
)

export default KetenverbandClient
